type AdaFieldErrorProps = {
  errorMessage?: string
}

export function AdaFieldError({ errorMessage }: AdaFieldErrorProps) {
  return <div className="mt-1 text-xs text-red-600">{errorMessage}</div>
}
